// Lazily activates the device-preview embed iframe. The iframe carries a
// real, narrower document viewport than the CSS-boxed .invite-frame it
// replaces for Tablet/Mobile — that's what makes a theme's own `@media`
// breakpoints (not just `@container` ones) respond correctly in preview.
// Loading is deferred to first selection so a desktop-only visitor never
// pays for a second full page load.
document.addEventListener("change", (event) => {
  if (event.target.name !== "demo-device") return
  if (event.target.value !== "tablet" && event.target.value !== "mobile") return

  const embed = document.querySelector(".demo-invitation-stage__embed")
  if (embed && !embed.getAttribute("src")) {
    embed.src = embed.dataset.embedSrc
  }
})
